export const enum LANGUAGE {
  JAPAN = 'jp',
  ENGLISH = 'en',
}

export const enum ROLES {
  USER_PARENT = 'USER_PARENT',
  USER_MANAGER = 'USER_CHILD_MANAGER',
  USER_VIEWER = 'USER_CHILD_VIEWER',
  USER_FACILITY_MANAGEMENT = 'USER_FACILITY_MANAGEMENT',
  USER_BROWSE_FACILITY = 'USER_BROWSE_FACILITY',
  USER_REGISTRATION = 'USER_REGISTRATION',
}

export const enum DocumentType {
  FILE = 'file',
  FOLDER = 'folder',
}

export const enum UploadFolderDuplicate {
  OVERWRITE = 'overwrite',
  NEWUPLOAD = 'newUpload',
}

export const enum UploadFolderType {
  DIRECTLY = 'directly',
  CONFIRM = 'confirm',
}

export const enum UploadFolderStatus {
  SUCCESS = 'Success',
  FAIL = 'Fail',
}

export const enum SortFolderField {
  NAME = 'name',
  LASTMODIFIED = 'lastModified',
}

export const enum SortType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const enum SortBy {
  NAME = 'name',
  LASTMODIFIED = 'updated_at',
}

export const enum ReduxProps {
  DATA_BRANCH = 'dataBranch',
  DATA_BRANCH_UPLOAD = 'dataBranchUpload',
}

export const enum Analysis {
  ALL = 'all',
  SCOPE_1 = 'scope1',
  SCOPE_2 = 'scope2',
  SCOPE_3 = 'scope3',
  OTHER = 'other',
  REPORT = 'report',
}

export enum ScopeType {
  SCOPE1 = 1,
  SCOPE2 = 2,
  SCOPE3 = 3,
}

export const enum TYPE_ERROR_CSV {
  EMPTY = 'empty',
  FORMAT = 'formar',
  EMISSION = 'emission',
  BRANCH_ITEM = 'branch_item',
}

export const enum FACILITY {
  ITEM_PER_PAGE = 30,
}

export const enum inviteStatus {
  PENDING = 1,
  APPROVED = 2,
}

export const enum NOTIFICATION {
  ITEM_PER_PAGE = 20,
}

export const enum NOTIFICATION_TYPE {
  NOTIFICATION = 'notification',
  TRIVIA = 'trivia',
  REQUEST = 'request',
  APPROVED = 'approved',
  SHARED = 'shared',
  REQUEST_SHARE = 'request_share',
  UPDATE_SHARE = 'update_share',
}

export const COLLABORATION_STATUS = {
  SENDING: 1,
  APPROVED: 2,
}

export enum SEARCH_ANALYSIS_TYPE {
  COMPANY = 'company',
  GROUP = 'group',
}

export enum TARGET_SELECT_YEAR_TYPE {
  MONTH_YEAR = 'MONTH_YEAR',
  YEAR = 'YEAR',
}

export const enum COLLABORATION_TYPE {
  IN_INTEGRATION = 'in_integration',
  NOT_INTGRATED = 'not_integrated',
}

export const enum GOAL_VERSION_STATUS {
  PREPARING = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
}

export const enum GOAL_TYPE_STATUS {
  // 削減対策を検索する
  GENERAL = 1,
  // 独自の削減対策
  UNIQUE = 2,
}

export const enum GOAL_STRATEGY_ITEM {
  CITY_GAS = '都市ガス',
  KEROSENE = '灯油',
  GASOLINE = 'ガソリン',
  LIGHT_OIL = '軽油',
  PURCHASED_ELECTRICITY = '購入電力',
}

export enum ANALYSIS_TYPE_OTHER {
  TOP_EMISSION = '',
  MONTHLY_TREND = '1',
  CHANGE_FACILITY = '3',
  YEAR_EMISSION = '4',
  MAIN_ENERGY_EMISSION_TRENDS = '5',
}

export enum ANALYSIS_TYPE_SCOPE1 {
  TOTAL_EMISSION = '1',
  FUEL = '3',
  GASOLINE = '4',
  CITY_GAS = '5',
  DIESEL = '6',
  FACILITY_EMISSION = '7',
}

export enum ANALYSIS_TYPE_SCOPE2 {
  TOTAL_EMISSION = '1',
  CONSUMPTION = '2',
  ELECTRICITY = '3',
  FACILITY_EMISSION = '4',
}

export enum ANALYSIS_TYPE_SCOPE3 {
  TOTAL_EMISSION = '1',
  COST_TREND = '3',
  CATEGORY = '4',
  TAP_WATER = '5',
  FACILITY_EMISSION = '6',
  PAPER = '7',
}

export enum MAX_DECIMAL_DIGITS {
  _4 = 4,
  _10 = 10,
  _12 = 12,
}

export enum ESortColumn {
  REGISTRATION_DATE = 'registrationDate',
  EMISSION_AMOUNT = 'emissionAmount',
}

export enum EFileType {
  EXCEL,
  CSV,
}

export enum EMISSION_UNIT {
  CUBIC_METER = 'm3',
  LITRE = 'l',
  PIECE = '枚',
}

export enum INPUT_EMISSION_AMOUNT_DECIMAL_PRECISION {
  MAX_INTEGER_DIGITS = 10,
  MAX_DECIMAL_DIGITS = 20,
  MAX_INTEGER_DIGITS_EMISSION_AMOUNT = 18,
}

export enum ACTION {
  COPY = 'copy',
}

export enum DASHBOARD_SCOPE_TYPE {
  SCOPE1_DASHBOARD = 'scope1',
  SCOPE2_DASHBOARD = 'scope2_dashboard',
  SCOPE2_LOCATION_DASHBOARD = 'scope2_location',
  SCOPE3_DASHBOARD = 'scope3',
  TOTAL_DASHBOARD = 'total_dashboard',
  TOTAL_LOCATION_DASHBOARD = 'location_total',
}

export enum EMISSION_BASED {
  MARKET = 'market',
  LOCATION = 'location',
}
